<div class="kal-calendar-multi-view__wrapper">

  <!-- Months list -->
  <div class="kal-calendar-multi-view__month">
    <div [class.selected-month]="isMonthSelected(i)"
         *ngFor="let month of shortMonths; index as i"
         (click)="selectDate({unit: 'months', value: i})">
      {{ month }}
    </div>
  </div>

  <!-- Years list -->
  <div class="kal-calendar-multi-view__year">
    <div *ngFor="let year of years"
         [class.selected-year]="isYearSelected(year)"
         (click)="selectDate({unit: 'years', value: year})">
      {{ year }}
    </div>
  </div>

</div>
